import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useState,
} from 'react';
import { useWindowDimensions } from 'react-native';
import Carousel, { Pagination } from 'react-native-snap-carousel';
import { useTheme } from 'styled-components/native';
import WebModal, { WebModalHandler } from '~/components/WebModal';
import {
  Content,
  CarouselContainer,
  FullImageContainer,
  FullImage,
  PaginationContainer,
  CONTAINER_WIDTH,
  MODAL_CHROME_HEIGHT,
  MIN_IMAGE_HEIGHT,
} from './style';

export type WebModalFullImageHandler = WebModalHandler;

export type WebModalFullImageProps = {
  testID?: string;
  imgUrls: string[];
  selectedImgIndex: number;
  onClose: () => void;
};

const WebModalFullImage: ForwardRefRenderFunction<
  WebModalFullImageHandler,
  WebModalFullImageProps
> = ({ testID, imgUrls, selectedImgIndex, onClose }, ref) => {
  const theme = useTheme();
  const { height: windowHeight } = useWindowDimensions();
  const maxImageHeight = Math.max(
    MIN_IMAGE_HEIGHT,
    windowHeight - MODAL_CHROME_HEIGHT,
  );
  const [activeIndex, setActiveIndex] = useState(selectedImgIndex);

  useEffect(() => {
    setActiveIndex(selectedImgIndex);
  }, [selectedImgIndex]);

  const renderImage = ({ item: imgUrl }: { item: string }) => (
    <FullImageContainer maxHeight={maxImageHeight}>
      <FullImage source={{ uri: imgUrl }} fitHeight={maxImageHeight} />
    </FullImageContainer>
  );

  return (
    <WebModal ref={ref} sizeWidth={CONTAINER_WIDTH} onCloseModal={onClose}>
      <Content testID={testID}>
        <CarouselContainer>
          <Carousel
            key={`s${selectedImgIndex}`}
            data={imgUrls}
            renderItem={renderImage}
            sliderWidth={CONTAINER_WIDTH}
            itemWidth={CONTAINER_WIDTH}
            inactiveSlideScale={1.0}
            inactiveSlideOpacity={1.0}
            firstItem={selectedImgIndex}
            onSnapToItem={setActiveIndex}
            removeClippedSubviews={false}
          />
        </CarouselContainer>
        <PaginationContainer>
          <Pagination
            key={`s${selectedImgIndex}`}
            dotsLength={imgUrls.length}
            activeDotIndex={activeIndex}
            containerStyle={{
              backgroundColor: theme.color.base.c1,
              paddingHorizontal: 8,
              paddingVertical: 6,
              borderRadius: 10,
            }}
            dotContainerStyle={{
              marginHorizontal: 2,
            }}
            dotStyle={{
              height: 10,
              width: 10,
              borderRadius: 5,
              backgroundColor: theme.color.base.c5,
            }}
            inactiveDotStyle={{
              height: 10,
              width: 10,
              borderRadius: 5,
              backgroundColor: theme.color.base.c3,
            }}
            inactiveDotOpacity={1.0}
            inactiveDotScale={1.0}
          />
        </PaginationContainer>
      </Content>
    </WebModal>
  );
};

export default forwardRef(WebModalFullImage);
